import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AddConnectionRequest } from 'src/app/domains/connectivity/models/connectivity.model';
import { ConnectivityService } from 'src/app/domains/connectivity/services/connectivity.service';

@Component({
  selector: 'gdp-add-connection-popup',
  templateUrl: './add-connection-popup.component.html',
  styleUrls: ['./add-connection-popup.component.scss']
})
export class AddConnectionPopupComponent implements OnInit {
  public companyId: number;
  public step: 'form' | 'explanation';
  public form: UntypedFormGroup;
  public loading: boolean = false;
  @Output() onAddConnection: EventEmitter<string> = new EventEmitter();

  constructor(
    private activeModal: NgbActiveModal,
    private fb: UntypedFormBuilder,
    private connectivityService: ConnectivityService
  ) {}

  ngOnInit(): void {
    this.step = 'form';
    this.form = this.fb.group({
      providerReferenceId: new UntypedFormControl('', [Validators.required])
    });
  }

  public isFieldValid(name: string): boolean {
    const control = this.form.controls[name];
    return control.touched && !control.valid;
  }

  public addConnection(): void {
    if(this.form.valid) {
      const providerValue = this.form.controls.providerReferenceId.value;
      const payload: AddConnectionRequest = {
        company_id: this.companyId,
        provider_reference_id: providerValue
      };
      this.loading = true;
      this.connectivityService.addConnection(payload).subscribe(() => {
        this.onAddConnection.emit('company.connectivity.add-connection-popup.success');
        this.loading = false;
        this.close();
      }, () => {
        this.loading = false;
        this.close();
      });
    }
  }

  public close(): void {
    this.activeModal.close();
  }
}